import moment from "moment";
import _isEmpty from "lodash/isEmpty";

import { COLORS, DATE_FORMATS, METRIC_TYPES } from "../constants/global";

const getValue = (point, type) => {
  return type === METRIC_TYPES.REQUEST_LATENCY ? point[1] : +Boolean(point[1]) * 100;
};

const convertMetrics = (data, type) => {
  let formattedPoints = [];
  data.forEach((line, index) => {
    const name = line[4];
    const points = type === METRIC_TYPES.REQUEST_LATENCY ? line[0] : line[1];
    const abbr = name.split("-");
    const shortName = abbr[0][0] + abbr[1][0];
    let arr = points.map((point) => {
      return {
        name,
        [shortName]: getValue(point, type),
        amt: point[0][0],
        type: shortName,
        color: COLORS[index],
        value: getValue(point, type)
      };
    });
    formattedPoints.push(arr);
  });
  return formattedPoints;
};

const toDateTime = (secs) => {
  const date = new Date(secs * 1000);
  return moment(date).format(DATE_FORMATS.MMMDDYYYY) + ", " + formatXAxis(secs);
};

const formatDate = (date) => moment(date).format(DATE_FORMATS.MMMDDYYYYHMM);

const formatXAxis = (timeStr) => {
  const date = new Date(timeStr * 1000);
  return moment(date).format(DATE_FORMATS.MMMDDHH);
};

const getGeneralDate = (data) => {
  const allDates = data.map((item) => parseFloat(item.amt));
  const maxDate = Math.max.apply(null, allDates);
  return toDateTime(maxDate);
};

const getDefaultBeforeDate = () => {
  const today = new Date();
  // get previous hour
  return today - 3600 * 24 * 1000;
};

const getYDomain = (chartData) => {
  // Numbers are used to help find min and max values in array of data
  // they are initial values and are used just for first step
  let minDomain = 1000;
  let maxDomain = 100;
  chartData.forEach((chart) => {
    const sortedData = chart.map((chartItem) => Object.values(chartItem)[1]);
    const minValue = Math.min(...sortedData);
    const maxValue = Math.max(...sortedData);
    if (minValue < minDomain) {
      minDomain = minValue;
    }
    if (maxValue > maxDomain) {
      maxDomain = maxValue;
    }
  });
  return [Math.floor(minDomain - 100), Math.floor(maxDomain + 100)];
};

const formatDateWithoutTimezone = (date) => moment(date).format(DATE_FORMATS.YYYYMMDD);

const getPercentUptime = (data) => {
  const totalChecksCount = data.reduce((acc, item) => item.length + acc, 0);
  let passedChecksCount = 0;
  data.forEach((item) => {
    item.forEach((item) => {
      if (item.value) {
        passedChecksCount++;
      }
    });
  });
  return totalChecksCount > 0 ? (passedChecksCount / totalChecksCount) * 100 : 0;
};

const getAverageLatency = (data) => {
  if (_isEmpty(data)) return 0;
  const value = data.map((item) => item[item.length - 1].value).reduce((acc, item) => acc + item, 0);
  return value / data.length;
};

const formatPercentTick = (tick) => `${tick}%`;

export {
  convertMetrics,
  formatPercentTick,
  formatDateWithoutTimezone,
  formatDate,
  formatXAxis,
  getGeneralDate,
  getDefaultBeforeDate,
  getPercentUptime,
  getAverageLatency,
  getYDomain
};
